import axios from "../../request";

const GET_TOP_PEOPLES = 'people/gettoppeoples';
const GET_PEOPLE_FOR_DETAIL = 'people/getpeoplefordetail';
const GET_PEOPLES = 'people/getpeoples'


export const getTopPeoples = (params) => axios.post(GET_TOP_PEOPLES, params);
export const getPeopleForDetail = (params) => axios.post(GET_PEOPLE_FOR_DETAIL, params);
export const getPeoples = (params = {}) => axios.post(GET_PEOPLES, params);